import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentConvictionModel } from '../models/incident-conviction.model';

@Injectable()
export class ConvictionIncidentService extends IncidentServiceBase<IncidentConvictionModel> {
    constructor() {
        super('IncidentConviction', () => new IncidentConvictionModel());
    }

    public getLookups() {
        return this.get('Incident/IncidentConviction/lookups');
    }

    public getCredentials(customerNumId: number) {
        return this.get(`Driver/Credential/TopStack?customerNumberId=${customerNumId}`);
    }

    public getSentencingAuthorities() {
        return this.get('Incident/SentencingAgencies');
    }

    public getConvictionsByWithdrawals(prohibitionId: number) {
        return this.get(`Incident/prohibition/convictions/${prohibitionId}`);
    }

    public getRooscsByProhibitionsId(prohibitionId: number) {
        return this.get(`Incident/prohibition/rooscs/${prohibitionId}`);
    }

    public getRooscByIncidentNumberId(incidentNumberId: number) {
        return this.get(`Incident/roosc/${incidentNumberId}`);
    }

    public getCustomersLastConviction(customerNumberId: number) {
        return this.get(`Incident/IncidentConviction/latest/${customerNumberId}`);
    }

    public GetCourtDispositionCodeTypeByEffectiveDateAndDispositionTypeId(date: any, dispositionTypeId: number) {
        return this.get(`Incident/IncidentConviction/courtDispositionCodeTypes/${date}/${dispositionTypeId}`);
    }

    public getCourtDispositionCodeTypeByEffectiveDate(date: any) {
        return this.get(`Incident/IncidentConviction/courtDispositionCodeTypes/${date}`);
    }

    public getLegislativeChangeDateByEffectiveDate(date: any) {
        return this.get(`Incident/IncidentConviction/legislativeChangeDates/${date}`);
    }

    public getAllLegislativeChangeDates() {
        return this.get('Incident/IncidentConviction/allLegislativeChangeDates');
    }
}
